import React, { useState, useEffect } from 'react';
import { Entrycameramonitor } from '../../../../api/EntryCameraMonitorifl';
import { Col, Container, Row, Card, CardHeader, Input, Label, FormGroup, Button, Spinner } from 'reactstrap';
import FaceCardV2 from './FaceCardV2';
import PaginationComponent from './Pagination';
import './faceDetections.css';
import { getCurrentcompleteDate } from '../../../../utils/getCurrentcompleteDate';
import FiltersComponent from "../../pages/components/Filters/FiltersComponent";

import { errorToast } from '../../../../_helper/helper';
import ImageZoomSingleImage from '../../../Dashboards/AreaDashbaord/reports/Components/LiveAlertsCards/ImageZoomSingleImage';




const LOCAL_STORAGE_KEY = 'detection_page';

const FaceDetectionsQA = () => {


     //zoom image start
      const [showModal, setShowModal] = useState(false);
      const [imageUrl, setImageurl] = useState();
      const handleImageClick = (photo) => {
        console.log('photttt', photo)
        setImageurl(photo);
        setShowModal(!showModal);
      };
      //zoom image End


    const getInitialFilters = () => {
        const savedFilters = localStorage.getItem(LOCAL_STORAGE_KEY);
        return savedFilters
            ? JSON.parse(savedFilters)
            : {
                selectDate: 'date',
                time: '',
                week: '',
                date: getCurrentcompleteDate(),
                month: '',
                shift: '',
                starting: '',
                ending: ''
            };
    };
    const [detections, setDetections] = useState([]);
    const [statistics, setStatistics] = useState({
        total_alerts: 0,
        total_client_verified: 0,
        pending: 0
    });
    // const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(12);
    const [employeeFilter, setEmployeeFilter] = useState('');
    const [filters, setFilters] = useState(getInitialFilters)
    const [callApi, setCallAPi] = useState(false)
    const [loading, setloading] = useState(true)

    useEffect(() => {

        // setLoading(false);

        // When ready to use the API, uncomment this:
        getlivealertsdata();
    }, []);

    const getlivealertsdata = async () => {
        try {
            setloading(true);
            const userData = JSON.parse(localStorage.getItem('userData'));

            const payload = {
                client_id: userData?.client?.id,
                factory_id: userData?.factory?.id,
                limit: 100, // Get more data to handle pagination client-side
                camera_id: "",
                employee_id: "",
                filters: {
                    date: filters?.date,
                    week: filters?.week,
                    month: filters?.month,
                    starting: '',
                    ending: '',
                },
            };

            const res = await Entrycameramonitor.getLiveAlertss(payload);
            console.log('ressss', res?.data?.data)
            if (res.status === 200) {
                const data = res?.data?.data;
                setDetections(data?.logs || []);

                // Update statistics
                const totalAlerts = data?.total_alerts || 0;
                const totalClientVerified = data?.total_client_verified || 0;
                const pending = totalAlerts - totalClientVerified;

                setStatistics({
                    total_alerts: totalAlerts,
                    total_client_verified: totalClientVerified,
                    pending: pending
                });
            }
        } catch (error) {
            console.error("Error fetching face detections:", error);
        } finally {
            setloading(false);
        }
    };

    // Function to update specific detection without full refresh
    const updateDetectionStatus = (logId, verifiedStatus) => {
        setDetections(prevDetections =>
            prevDetections.map(detection =>
                detection.log_id === logId
                    ? { ...detection, client_verified: verifiedStatus }
                    : detection
            )
        );

        // Update statistics when a detection is verified
        setStatistics(prevStats => ({
            ...prevStats,
            total_client_verified: prevStats.total_client_verified + 1,
            pending: prevStats.pending - 1
        }));
    };

    const handleSave = () => {
        const updatedFilters = {
            selectDate: filters.selectDate,
            time: '',
            week: '',
            date: '',
            month: '',
            shift: filters.shift,
            starting: '',
            ending: '',
        };

        switch (filters.selectDate) {
            case 'date':
                if (!filters.date) {
                    errorToast('Please select a Date!');
                    return;
                }
                updatedFilters.date = filters.date;
                break;
            case 'week':
                if (!filters.week) {
                    errorToast('Please select a Week!');
                    return;
                }
                updatedFilters.week = filters.week;
                break;
            case 'month':
                if (!filters.month) {
                    errorToast('Please select a Month!');
                    return;
                }
                updatedFilters.month = filters.month;
                break;
            case 'custom':
                if (!filters.starting || !filters.ending) {
                    errorToast('Please select both Startin and Ending Dates!');
                    return;
                }
                updatedFilters.starting = filters.starting;
                updatedFilters.ending = filters.ending;
                break;
            default:
                break;
        }
        getlivealertsdata()
        setFilters(updatedFilters);
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedFilters));
        // setCallAPi((prev) => !prev);
    }
    const handleCancel = () => {
        const updatedFilters = {
            selectDate: 'date',
            time: '',
            week: '',
            date: getCurrentcompleteDate(),
            month: '',
            shift: '',
            starting: '',
            ending: ''
        };
        getlivealertsdata()
        setFilters(updatedFilters)
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedFilters));
        // setCallAPi(!callApi)
    }

    // Filter detections by camera position
    const gateInDetections = detections.filter(
        detection => detection.camera_position_no === "Gate In"
    );

    const gateOutDetections = detections.filter(
        detection => detection.camera_position_no === "Gate Out"
    );

    // Filter detections by camera position and other filters
    const filterDetections = (detectionsList) => {
        return detectionsList.filter(detection => {
            const matchesEmployee = !employeeFilter ||
                detection.employee_name.toLowerCase().includes(employeeFilter.toLowerCase()) ||
                detection.employee_id.toLowerCase().includes(employeeFilter.toLowerCase());

            // If time filter is set, check if detection hour matches
            let matchesTime = true;
            if (filters.time) {
                // Extract hour from filter time (format "HH:MM")
                const filterHour = filters.time.split(':')[0];

                // Extract hour from detection datetime
                const detectionTime = new Date(detection.detection_datetime);
                const detectionHour = String(detectionTime.getHours()).padStart(2, '0');

                // Compare hours only
                matchesTime = detectionHour === filterHour;
            }

            return matchesEmployee && matchesTime;
        });
    };
    console.log('filterss', filters);


    const filteredGateInDetections = filterDetections(gateInDetections);
    const filteredGateOutDetections = filterDetections(gateOutDetections);

    // Pagination logic
    const indexOfLastInItem = currentPage * itemsPerPage;
    const indexOfFirstInItem = indexOfLastInItem - itemsPerPage;
    const currentGateInItems = filteredGateInDetections.slice(indexOfFirstInItem, indexOfLastInItem);
    const currentGateOutItems = filteredGateOutDetections.slice(indexOfFirstInItem, indexOfLastInItem);

    const totalPages = Math.ceil(
        Math.max(filteredGateInDetections.length, filteredGateOutDetections.length) / itemsPerPage
    );

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    return (
        loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                <Spinner style={{ width: '3rem', height: '3rem', color: '#8B9736' }} />
            </div>
        ) : (
            <Container fluid className='dashboard-first-page'>
                <Row className="mb-3">
                    <Col>
                        <h1 style={{ fontSize: "24px", color: "#8B9736", fontWeight: "600" }}>All Detections</h1>
                        <div className='d-flex gap-4 mt-4'>
                            <div>
                                <h6 className="text-muted mb-1" style={{ fontSize: "14px", fontWeight: "500" }}>Total Alerts:</h6>
                                <h4 style={{ color: "#6c757d", fontWeight: "600", margin: "0" ,textAlign:"center"}}>{statistics.total_alerts}</h4>
                            </div>
                            <div>
                                <h6 className="text-muted mb-1" style={{ fontSize: "14px", fontWeight: "500" }}>Verified:</h6>
                                <h4 style={{ color: "#28a745", fontWeight: "600", margin: "0",textAlign:"center" }}>{statistics.total_client_verified}</h4>
                            </div>
                            <div>
                                <h6 className="text-muted mb-1" style={{ fontSize: "14px", fontWeight: "500" }}>Pending:</h6>
                                <h4 style={{ color: "#ffc107", fontWeight: "600", margin: "0",textAlign:"center" }}>{statistics.pending}</h4>
                            </div>
                        </div>
                    </Col>
                    <Col xs="12" xl="12" className="d-flex flex-wrap justify-content-end align-items-end">
                        <FiltersComponent setFilters={setFilters}
                            filtersConfig={[
                                // { key: "cameraType", options: ["OCR", "HSE"], placeholder: "Vehicle Type" },
                                // { key: "shift", options: ["Shift A", "Shift B"], placeholder: "Shift" },
                                { key: "selectDate", options: ["date", "week", 'month'], placeholder: "date" },
                            ]}
                            timeFilter={true}
                            handleSave={handleSave}
                            handleCancel={handleCancel}
                            filters={filters}
                        />
                    </Col>
                </Row>
                <Row>
                    {/* Gate In Section */}
                    <Col md="6">
                        <Card className="mb-4">
                            <CardHeader style={{ backgroundColor: '#8B9736' }} className="text-white">
                                <h5 className="mb-0">Entry Detections</h5>
                            </CardHeader>
                            <div className="p-2">

                                <Row>
                                    {currentGateInItems.map((detection) => (
                                        <Col md="6" xxl='6' lg='12' className='mb-2' key={detection.log_id} >
                                            <FaceCardV2 handleImageClick={handleImageClick} loading={loading} detection={detection} onStatusUpdate={updateDetectionStatus} />
                                        </Col>
                                    ))}
                                </Row>

                                <div className="text-center py-5">No Gate In detections found</div>

                            </div>
                        </Card>
                        {filteredGateInDetections.length > itemsPerPage && (
                            <PaginationComponent
                                currentPage={currentPage}
                                totalPages={Math.ceil(filteredGateInDetections.length / itemsPerPage)}
                                onPageChange={handlePageChange}
                            />
                        )}
                    </Col>

                    {/* Gate Out Section */}
                    <Col md="6">
                        <Card className="mb-4">
                            <CardHeader style={{ background: '#3a7bd5' }} className=" text-white">
                                <h5 className="mb-0">Exit Detections</h5>
                            </CardHeader>
                            <div className="p-2">

                                <Row>
                                    {currentGateOutItems.map((detection) => (
                                        <Col md="6" xxl='6' lg='12' className='mb-2' key={detection.log_id} >
                                            <FaceCardV2 handleImageClick={handleImageClick} detection={detection} onStatusUpdate={updateDetectionStatus} />
                                        </Col>
                                    ))}
                                </Row>

                                <div className="text-center py-5">No Gate Out detections found</div>

                            </div>
                        </Card>
                        {filteredGateOutDetections.length > itemsPerPage && (
                            <PaginationComponent
                                currentPage={currentPage}
                                totalPages={Math.ceil(filteredGateOutDetections.length / itemsPerPage)}
                                onPageChange={handlePageChange}
                            />
                        )}
                    </Col>
                </Row>


                {showModal && (
                          <ImageZoomSingleImage
                            photo={imageUrl}
                            setShowModal={setShowModal}
                          />
                        )}

            </Container>
        )
    );
};

export default FaceDetectionsQA;
